import type { RouteRecordRaw } from 'vue-router';

export default [
    {
        path: '/teams',
        name: 'teams.index',
        component: () => import('./pages/teams/Index.vue'),
        meta: {
            layout: 'app',
        },
    },
    {
        path: '/roles',
        name: 'roles.index',
        component: () => import('./pages/users/Index.vue'),
        meta: {
            layout: 'app',
        },
    },
    {
        path: '/contacts',
        name: 'contacts.index',
        component: () => import('./pages/contacts/Index.vue'),
        meta: {
            layout: 'app',
        },
    },
    {
        path: '/licenses',
        name: 'licenses.index',
        component: () => import('./pages/licenses/Index.vue'),
        meta: {
            layout: 'app',
        },
    },
    {
        path: '/teams/:id',
        name: 'teams.show',
        component: () => import('./pages/teams/Show.vue'),
        meta: {
            layout: 'app',
        },
    },
    {
        path: '/users/:id',
        name: 'users.show',
        component: () => import('./pages/users/Show.vue'),
        meta: {
            layout: 'app',
        },
    },
    {
        path: '/contacts/:id',
        name: 'contacts.show',
        component: () => import('./pages/contacts/Show.vue'),
        meta: {
            layout: 'app',
        },
    },
] satisfies RouteRecordRaw[];
